import type { QBankStructureLevel } from '@exam-management/qbs-provider';
import { useNavigate } from '@exam-management/router';
import { Dialog, DialogTitle } from '@shared/components';

import SetupQBankStructureLevelForm from '../../components/setup-qbank-structure-form/setup-qbank-structure-form';
import { useQBankStructureCreationModal } from '../../providers';

interface SetupQBankStructureLevelModalProps {
  open: boolean;
  onClose: () => void;
}

export default function SetupQBankStructureLevelModal(
  props: Readonly<SetupQBankStructureLevelModalProps>,
) {
  const { open: isOpen, onClose } = props;
  const navigate = useNavigate();
  const {
    qBankStructureLevels,
    qBankStructureId,
    submitSetupQBankStructureLevelForm,
    isUpdateQBankStructureLevelsLoading,
  } = useQBankStructureCreationModal();

  const handleClose = (event: React.SyntheticEvent, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (reason === 'backdropClick') {
      return;
    }
    if (reason === 'escapeKeyDown') {
      return;
    }
    onClose();
  };

  const onSetupLevelSubmit = async (
    updatedQBankStructureLevels: QBankStructureLevel[],
  ): Promise<void> => {
    await submitSetupQBankStructureLevelForm(updatedQBankStructureLevels);
    navigate('/qbank-structures/:structureId', {
      params: { structureId: qBankStructureId ?? '' },
    });
  };

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth='xs'>
      <DialogTitle
        sx={{
          borderBottom: '1px solid',
          borderBottomColor: (theme) => theme.palette.divider,
        }}
      >
        ตั้งค่าระดับโครงสร้าง
      </DialogTitle>
      <SetupQBankStructureLevelForm
        qBankStructureLevels={qBankStructureLevels}
        onClose={onClose}
        onSetupLevelSubmit={onSetupLevelSubmit}
        loading={isUpdateQBankStructureLevelsLoading}
      />
    </Dialog>
  );
}
